<template>
    <el-button :type="type" v-bind="$attrs" v-on="$listeners">
        <span v-if="$slots.default">
            <slot></slot>
        </span>
    </el-button>
</template>

<script>
export default {
    props: {
        type:{
            type:String,
            default:'default'
        }
    },
    computed: {},
    created() {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
$primary189: #1890FF;
$primary40A : #40A9FF;
$primary0C7 : #0C74E1;
$primary8BC: #8BC7FF;
$primaryE8F: #E8F4FF;
$primaryD9E: #D9EDFF;
// $primaryDisabled:#9EC5FF;
$successColor: #07C160;
$successHover: #2BCD74;
$successActive: #2BCD74;
$successFocus: #04A457;
// $successDisabled: #81E6A8;
$dangerF54: #F54A45;
$dangerF76: #F76B66;
$dangerD03: #D03F3B;
$dangerFAA: #FAA4A2;
$dangerF63: #F63838;
$dangerF85: #F85E5E;
$dangerFDD: #FDDEDE;
$dangerFCC: #FCC5C5;
// $dangerDisabled: #FFB0A8;
$info1F2: #1F2329;
$infoD3: #D3D3D5;
$infoF0F: #F0F1F3;
$infoE2E: #E2E3E4;
// $infoD3: #D3D3D5;
// $infoD9: #D9D9D9;
// $infoDisabled: #FFDCA9;
$commonColor: #fff;
$fontColor: #333;
$smallSize: 24px;
$largeSize: 40px;
$disabledB8: #B8B8B8;
$disabledB5: #F5F5F5;
$disabledD9: #D9D9D9;


.el-button {
    height: 32px;
    padding: 6px 12px;
    font-size: 14px;
    border-radius: 2px;
}

.el-button--small {
    height: 28px;
    padding: 4px 10px;
    font-size: 14px;
}
.el-button--mini{
    height: 24px;
    padding: 2px 8px;
    font-size: 14px;
}
.el-button.is-disabled {
    background-color: $infoF0F;
    color: $disabledB8 ;
    border: 1px solid $disabledD9 ;
    &:hover {
        background-color: $infoF0F;
        color: $disabledB8;
        border: 1px solid $infoF0F;
    };

    &:focus {
        background-color: $infoF0F;
        color: $disabledB8;
        border: 1px solid $infoF0F;
    }

    &:active {
        background-color: $infoF0F;
        color: $disabledB8;
        border: 1px solid $infoF0F;
    }
}
.el-button--text.is-disabled{
    border:1px solid transparent;
    background-color: transparent;
    color: $disabledB8;
    &:hover {
        background-color: transparent;
        color: $disabledB8;
        border: 1px solid transparent;
    };

    &:focus {
        background-color: transparent;
        color: $disabledB8;
        border: 1px solid transparent;
    }

    &:active {
        background-color: transparent;
        color: $disabledB8;
        border: 1px solid transparent;
    }
}
// .el-button--primary
.el-button--text {
    background-color: transparent;
    color: $primary189;
    border: none;

    &:hover {
        background-color: transparent;
        color: $primary40A;
        border: none;
    };

    &:focus {
        background-color: transparent;
        color: $primary40A;
        border: none;
    }

    &:active {
        background-color: transparent;
        color: $primary0C7;
        border: none;
    }
}
.el-button--primary.is-disabled{
    border:1px solid $primary8BC;
    background-color: $primary8BC;
    color: $commonColor;
    &:hover {
        background-color: $primary8BC;
        color: $commonColor;
        border: 1px solid $primary8BC;
    };

    &:focus {
        background-color: $primary8BC;
        color: $commonColor;
        border: 1px solid $primary8BC;
    }

    &:active {
        background-color: $primary8BC;
        color: $commonColor;
        border: 1px solid $primary8BC;
    }
}
.el-button--primary.is-plain.is-disabled {
    background-color: $infoF0F;
    color: $disabledB8 ;
    border: 1px solid $disabledD9 ;
    &:hover {
        background-color: $infoF0F;
        color: $disabledB8;
        border: 1px solid $infoF0F;
    };

    &:focus {
        background-color: $infoF0F;
        color: $disabledB8;
        border: 1px solid $infoF0F;
    }

    &:active {
        background-color: $infoF0F;
        color: $disabledB8;
        border: 1px solid $infoF0F;
    }
}
.el-button--primary.is-plain {
    background-color: $commonColor;
    color: $primary189;
    border: 1px solid $primary189;

    &:hover {
        background-color: $primaryE8F;
        color: $primary40A;
        border: 1px solid $primary40A;
    };

    &:focus {
        background-color: $primaryE8F;
        color: $primary40A;
        border: 1px solid $primary40A;
    }

    &:active {
        background-color: $primaryD9E;
        color: $primary0C7;
        border: 1px solid $primary0C7;
    }
}

.el-button--primary {
    background-color: $primary189;
    color: $commonColor;
    border: 1px solid $primary189;

    &:hover {
        background-color: $primary40A
    };

    &:focus {
        background-color: $primary40A;
    }

    &:active {
        background-color: $primary0C7;
    }
}
.el-button--danger.is-disabled{
    border:1px solid $dangerFAA;
    color: $commonColor;
    background-color: $dangerFAA;
    &:hover {
        background-color: $dangerFAA;
        color: $commonColor;
        border: 1px solid $dangerFAA;
    };

    &:focus {
        background-color: $dangerFAA;
        color: $commonColor;
        border: 1px solid $dangerFAA;
    }

    &:active {
        background-color: $dangerFAA;
        color: $commonColor;
        border: 1px solid $dangerFAA;
    }
}
.el-button--danger.is-plain.is-disabled {
    background-color: $infoF0F;
    color: $disabledB8 ;
    border: 1px solid $disabledD9 ;
    &:hover {
        background-color: $infoF0F;
        color: $disabledB8;
        border: 1px solid $infoF0F;
    };

    &:focus {
        background-color: $infoF0F;
        color: $disabledB8;
        border: 1px solid $infoF0F;
    }

    &:active {
        background-color: $infoF0F;
        color: $disabledB8;
        border: 1px solid $infoF0F;
    }
}
.el-button--danger.is-plain {
    background-color: $commonColor;
    color: $dangerF63;
    border: 1px solid $dangerF54;

    &:hover {
        background-color: $dangerFDD;
        color: $dangerF85;
        border: 1px solid $dangerF76;
    };

    &:focus {
        background-color: $dangerFDD;
        color: $dangerF85;
        border: 1px solid $dangerF76;
    }

    &:active {
        background-color: $dangerFCC;
        color: $dangerD03;
        border: 1px solid $dangerD03;
    }
}

.el-button--danger {
    background-color: $dangerF54;
    color: $commonColor;
    border: 1px solid $dangerF54;

    &:hover {
        background-color: $dangerF76
    };

    &:focus {
        background-color: $dangerF76;
    }

    &:active {
        background-color: $dangerD03;
    }
}

// .el-button--info.is-plain{
//     background-color: $dangerF54;
//     color: $commonColor;
//     border: 1px solid $dangerF54;

//     &:hover{
//         background-color: $dangerF76
//     };
//     &:focus {
//         background-color: $dangerF76;
//     }
//     &:active{
//         background-color: $dangerD03;
//     }
// }
// .el-button--info.is-disabled{
//     border:1px solid $infoF0F;
//     background-color: $infoF0F;
//     &:hover {
//         background-color: $infoF0F;
//         color: $disabledB8;
//         border: 1px solid $infoF0F;
//     };

//     &:focus {
//         background-color: $infoF0F;
//         color: $disabledB8;
//         border: 1px solid $infoF0F;
//     }

//     &:active {
//         background-color: $infoF0F;
//         color: $disabledB8;
//         border: 1px solid $infoF0F;
//     }
// }
.el-button--info {
    background-color: $commonColor;
    color: $info1F2;
    border: 1px solid $infoD3;

    &:hover {
        background-color: $infoF0F;
        color: $info1F2;
        border: 1px solid $infoD3;
    };

    &:focus {
        background-color: $infoF0F;
        // background-color: red;
        color: $info1F2;
        border: 1px solid $infoD3;
    }

    &:active {
        background-color: $infoE2E;
        // background-color: red;
        color: $info1F2;
        border: 1px solid $infoD3;
    }
}</style>